// client/UrlTester.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { useState } from "@adornis/functional-lit/stateful.js";
import { webcomponent } from "@adornis/functional-lit/webcomponent.js";
import { html, nothing } from "lit";
import { checkRedirectUrl } from "../api/checkRedirectUrl.js";
import "../db/Redirect.js";
var urlTester = webcomponent(
  "x-url-tester",
  () => {
    const [inputUrl, setInputUrl] = useState("");
    const [isValid, setIsValid] = useState(void 0);
    const [matchedRedirect, setMatchedRedirect] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const checkUrl = async (url) => {
      if (!url) {
        setIsValid(void 0);
        setMatchedRedirect(null);
        setRedirectUrl("");
        return;
      }
      try {
        const result = await checkRedirectUrl(
          url,
          [],
          true
        )({
          redirect: {
            _id: 1,
            from: 1,
            to: 1,
            type: 1
          },
          redirectURL: 1
        });
        if (result) {
          setIsValid(true);
          setMatchedRedirect(result.redirect);
          setRedirectUrl(result.redirectURL);
        } else {
          setIsValid(false);
          setMatchedRedirect(null);
          setRedirectUrl("");
        }
      } catch (error) {
        console.error("Fehler beim Pr\xFCfen der URL:", error);
        setIsValid(false);
        setMatchedRedirect(null);
        setRedirectUrl("");
      }
    };
    return xComponents(html`
      <x-flex space="sm" ${css({ background: "#fff", borderRadius: "4px", padding: "16px" })}>
        <x-text>URL Tester</x-text>
        <x-flex space="sm" horizontal crossaxis-end>
          <x-input
            flex
            placeholder="URL zum Testen eingeben..."
            .value=${inputUrl}
            @keydown=${(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        checkUrl(inputUrl);
      }
    }}
            @value-changed=${(e) => {
      const value = e.detail.value;
      if (value === inputUrl)
        return;
      setInputUrl(value);
      setIsValid(void 0);
      setMatchedRedirect(null);
      setRedirectUrl("");
    }}
          ></x-input>
          <x-button @click=${() => checkUrl(inputUrl)} ?disabled=${!inputUrl}> Prüfen </x-button>
        </x-flex>

        ${isValid === void 0 ? nothing : isValid ? html`
              <div class="mt-4">
                <div class="alert alert-success">
                  <span>Diese URL wird abgefangen.</span>
                </div>
              </div>
            ` : html`
              <div class="mt-4">
                <div class="alert alert-warning">
                  <span>Diese URL wird von keinem Redirect abgefangen.</span>
                </div>
              </div>
            `}
        ${matchedRedirect ? html`
              <div class="mt-4">
                <div class="text-sm font-medium text-base-content/70">Gefundener Redirect:</div>
                <div class="text-sm break-all bg-base-200 p-2 rounded-lg mt-1">
                  <div class="flex justify-between items-center">
                    <span class="font-medium">Von:</span>
                    <span>${matchedRedirect.from}</span>
                  </div>
                  <div class="flex justify-between items-center mt-1">
                    <span class="font-medium">Nach:</span>
                    <span>${matchedRedirect.to}</span>
                  </div>
                  <div class="flex justify-between items-center mt-1">
                    <span class="font-medium">Typ:</span>
                    <span>${matchedRedirect.type === 301 ? "Permanent (301)" : "Tempor\xE4r (302)"}</span>
                  </div>
                </div>
              </div>
            ` : ""}
        ${redirectUrl ? html`
              <div class="mt-4">
                <div class="text-sm font-medium text-base-content/70">Redirect URL:</div>
                <div class="text-sm break-all bg-base-200 p-2 rounded-lg mt-1">${redirectUrl}</div>
              </div>
            ` : ""}
      </x-flex>
    `);
  },
  { shadowRoot: true }
);
export {
  urlTester
};
